export default __webpack_public_path__ + "static/media/fanny-profile1.337f6d4d.png";